import { supabase } from "../lib/supabaseClient";
import { VISION_URL } from "../config/domains";

const VISION_BASE = VISION_URL;

/**
 * Ouvre vision.artkiv.com en passant la session Supabase via hash fragment.
 * detectSessionInUrl: true côté vision récupère automatiquement les tokens.
 * @param {string} path  ex: "/visual-analysis?artworkId=123"
 */
export async function openVision(path = "") {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) {
    window.open(VISION_BASE + path, "_blank");
    return;
  }
  const expiresIn = session.expires_at
    ? Math.max(0, session.expires_at - Math.round(Date.now() / 1000))
    : 3600;
  const url =
    VISION_BASE +
    path +
    `#access_token=${session.access_token}&refresh_token=${session.refresh_token}&token_type=bearer&expires_in=${expiresIn}&expires_at=${session.expires_at ?? ""}`;
  window.open(url, "_blank");
}
